"use client";
import useEmblaCarousel from "embla-carousel-react";
import useIsRtl from "@/hooks/useIsRtl";
import { TEmblaSliderContextValue } from "./types";
import EmblaSliderContext from "./EmblaSliderContext";
import EmblaSliderContainer from "./EmblaSliderContainer";
import EmblaSliderPrevNextButtons from "./EmblaSliderPrevNextButtons";
import EmblaSliderViewport from "./EmblaSilderViewpoer";
import Autoplay from "embla-carousel-autoplay";
// import useAutoPlaySliderEffect from "./useAutoPlaySlider";
import EmblaFilters from "./EmblaFilters";
import useEmblaSliderFeatures from "./useEmblaSliderFeatures";

type TEmblaSettings = {
  autoPlay?: boolean;
  autoplayDuration?: number;
  setisLastSlide?: (isLastSlide: boolean) => void;
  selectedIndex?: number;
  setSelectedIndex?: (slide: number) => void;
  direction?: "vertical" | "horizantal";
};

type TProps = { children: React.ReactElement } & TEmblaSettings;

type EmblaSliderComponent = React.FC<TProps> & {
  EmblaSliderContainer: typeof EmblaSliderContainer;
  EmblaSliderPrevNextButtons: typeof EmblaSliderPrevNextButtons;
  EmblaSliderViewport: typeof EmblaSliderViewport;
  EmblaFilters: typeof EmblaFilters;
};

const EmblaSlider: EmblaSliderComponent = ({
  children,
  autoPlay = false,
  autoplayDuration = 5000,
  setisLastSlide,
  selectedIndex,
  setSelectedIndex,
  direction = "horizantal",
}) => {
  const buildPlugins = () => {
    let plugins: any[] = [];
    if (autoPlay) {
      plugins = [...plugins, Autoplay({ delay: autoplayDuration })];
    }
    return plugins;
  };
  const isRtl = useIsRtl();
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      direction: isRtl && direction === "horizantal" ? "rtl" : "ltr",
      axis: direction === "vertical" ? "y" : "x",
      // loop: autoPlay,
      skipSnaps: true,
    },
    buildPlugins(),
  );
  const contextValue: TEmblaSliderContextValue = [emblaRef, emblaApi];
  useEmblaSliderFeatures(
    emblaApi,
    selectedIndex,
    setSelectedIndex,
    setisLastSlide,
  );
  // useAutoPlaySliderEffect(autoPlay, emblaApi);
  return (
    <EmblaSliderContext.Provider value={contextValue}>
      {children}
    </EmblaSliderContext.Provider>
  );
};

EmblaSlider.EmblaSliderContainer = EmblaSliderContainer;
EmblaSlider.EmblaSliderPrevNextButtons = EmblaSliderPrevNextButtons;
EmblaSlider.EmblaSliderViewport = EmblaSliderViewport;
EmblaSlider.EmblaFilters = EmblaFilters;
export default EmblaSlider;
